import { FC, useContext, useEffect } from "react";
// import Emptymiddleware from '../middlewares/Emptymiddleware'
import TokenMiddlewareTable from "./Tokenmiddleware";

import { TableInputProps } from "../Table";

import store from "../../../store/store";
import { removeBreadcrumb } from "../../../components/Breadcrumbs/reducer/breadcrumbSlice";
import { GENERAL } from "../config/Transaction/ProductGeneralConf";
import { useSelector } from "react-redux";
import { fetchAllTags } from "../reducer/TagsSlice";
import { resetAddOfferRes } from "../reducer/TagsSlice";

const InitMiddlewareTable: FC<TableInputProps> = (props) => {
  const { categoryData } = useSelector((state: any) => state.rootReducer.brand);
  const { entityData, done } = useSelector((state: any) => state.DeletePopup);

  console.log("done", done);

  useEffect(() => {
    store.dispatch(fetchAllTags(null));
  }, []);

  useEffect(() => {
    store.dispatch(removeBreadcrumb());
  }, []);

  useEffect(() => {
    if (done) {
      store.dispatch(fetchAllTags(null));
    }
  }, [done]);

  useEffect(() => {
    store.dispatch(resetAddOfferRes()); // Reset addOfferRes after navigation
  }, []);

  return <TokenMiddlewareTable {...props} />;
};

export default InitMiddlewareTable;
